<template>
  <div class="about-page">
    <Header />
    <SmoothScroll>
    
      <WhatIsJujuna />
      <JujunaBottle />
      <JujunaPacks />
      <DraughtJujuna />
      <StickerBar :bgColor="'#BACB32'"/>
      <MobileBar />
      <Footer />
    </SmoothScroll>
  </div>
</template>

<script>
import SmoothScroll from "@/components/SmoothScroll";
import WhatIsJujuna from "@/components/smartComponents/WhatIsJujuna";
import JujunaBottle from "@/components/smartComponents/JujunaBottle";
import JujunaPacks from "@/components/smartComponents/JujunaPacks";
import MobileBar from "@/components/smartComponents/MobileBar";
import DraughtJujuna from "@/components/smartComponents/DraughtJujuna";
import StickerBar from "@/components/smartComponents/StickerBar";

import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
export default {
  components: {
    SmoothScroll,
    Header,
 
    WhatIsJujuna,
    JujunaBottle,
    JujunaPacks,
    DraughtJujuna,
    StickerBar,
    MobileBar,

    Footer,
   
  }
};
</script>

<style></style>
